import { FullScreenLoaderComponent } from 'baseComponents/FullScreenLoaderComponent';
import { ResultPage } from 'components/ResultPage';
import { useGetCurrentUser } from 'hooks/useGetCurrentUser';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from 'store/AuthStore';

export const PrivateRoutes = () => {
  const isLoggedIn = useAuthStore((store) => store.isLoggedIn);
  const accessToken = useAuthStore((store) => store.tokens.access_token);

  const { isLoading, error } = useGetCurrentUser({
    enabled: Boolean(accessToken),
  });
  const location = useLocation();

  if (error) {
    if (error?.response?.status === 401) {
      return <Navigate to='/' state={{ from: location }} replace />;
    }
    return <ResultPage title={JSON.stringify(error, null, 2)} />;
  }

  if (isLoading) {
    return <FullScreenLoaderComponent spinning />;
  }

  return isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to='/' state={{ from: location }} replace />
  );
};
